<script setup lang="ts">
import { ElInput, ElSelect, ElTreeV2 } from "element-plus";
import {
  inject,
  nextTick,
  onMounted,
  ref,
  shallowRef,
  useId,
  watch,
} from "vue";
import { SERVER_CONFIG, SITE_UNIT_STORE, USER_INFO } from "../../../utils";
import {
  TenantEnterpriseEmits,
  TenantEnterpriseProps,
} from "./tenant-enterprise";
import TreeLine from "./tree-line";

defineOptions({
  name: "ITenantEnterprise",
});

const props = defineProps(TenantEnterpriseProps);
const emits = defineEmits(TenantEnterpriseEmits);

const simpleModeBaseInfo = ref<any>({});
const systemConfig = props?.action?.serverConfig || inject(SERVER_CONFIG);
const isSimple = systemConfig?.menuMode === "simple";
const tenantStore = props?.action?.tenantStore || inject(SITE_UNIT_STORE);
const userStore = props?.action?.user || inject(USER_INFO);

const CHILDREN_KEY = "enterpriseTreeVoList";
const NODE_KEY = "id";

const modelValue = ref();
const loading = ref(false);
const treeRef = shallowRef();
const treeContainerId = useId();
const selectRef = shallowRef();
const searchValue = ref("");
const treeData = ref<any[]>([]);
// 默认选中
// 1、选中用户当前单位站点及其子节点；
// 2、simple模式下，默认选中接收到的单位站点(大屏那边目前都是单选)
const defaultCheck = ref<Record<string, any>>({
  enterpriseId: null,
  tenantId: null,
  name: null,
});
let cacheChangeKeys: any[] = [];

onMounted(async () => {
  treeData.value = await GetTenantEnterpriseTree();
  await setDefaultCheck();
});

watch(
  () => tenantStore?.currentTenantId,
  async () => {
    treeData.value = await GetTenantEnterpriseTree();
    await setDefaultCheck();
  },
);

window.microApp?.addDataListener((val: any) => {
  // 只在 simple 模式下运行
  // simple 模式下不显示单位选择框，所以无需更新视图，只需要触发emits.change，让组件调用者知道单位发生了变更即可。
  if (isSimple && val) {
    const obj = {
      name: val.enterpriseName,
      enterpriseId: val.enterpriseId,
      tenantId: val.tenantId,
    };
    emits("change", {
      arr: [obj],
      obj,
    });
  }
}, true);

/**
 * 获取租户下的所有单位树
 */
async function GetTenantEnterpriseTree(): Promise<any[]> {
  if (props.isOnDuty) {
    // return [{
    //     id: 23,
    //     enterpriseName: "特致珈",
    //     enterpriseNameShort: null,
    //     enterpriseLogoImage: null,
    //     sort: null,
    //     parentId: 0,
    //     tenantId: 32,
    //     condition: null,
    //     latLud: null,
    //     enterpriseTreeVoList: [
    //       {
    //         id: 3377298,
    //         enterpriseName: "特致珈子单位",
    //         enterpriseNameShort: null,
    //         enterpriseLogoImage: "",
    //         sort: null,
    //         parentId: 23,
    //         tenantId: 32,
    //         condition: "0",
    //         latLud: "113.015141,28.23635",
    //         enterpriseTreeVoList: [],
    //         fileNum: 0,
    //         auth: false,
    //         imgUrl: null,
    //         dutyName: null,
    //         dutyPhone: null,
    //         enterpriseStr: null,
    //         tenantTreeVoList: null,
    //         deptList: null,
    //         type: null,
    //       },
    //       {
    //         id: 3152351,
    //         enterpriseName: "数据中台流程测试单位",
    //         enterpriseNameShort: "string",
    //         enterpriseLogoImage: null,
    //         sort: 0,
    //         parentId: 23,
    //         tenantId: 32,
    //         condition: "0",
    //         latLud: null,
    //         enterpriseTreeVoList: [],
    //         fileNum: 0,
    //         auth: false,
    //         imgUrl: null,
    //         dutyName: null,
    //         dutyPhone: null,
    //         enterpriseStr: null,
    //         tenantTreeVoList: null,
    //         deptList: null,
    //         type: null,
    //       },
    //       {
    //         id: 3171158,
    //         enterpriseName: "函谷关",
    //         enterpriseNameShort: null,
    //         enterpriseLogoImage: "",
    //         sort: null,
    //         parentId: 23,
    //         tenantId: 32,
    //         condition: "0",
    //         latLud: "110.928567,34.636828",
    //         enterpriseTreeVoList: [],
    //         fileNum: 0,
    //         auth: false,
    //         imgUrl: null,
    //         dutyName: null,
    //         dutyPhone: null,
    //         enterpriseStr: null,
    //         tenantTreeVoList: null,
    //         deptList: null,
    //         type: null,
    //       },
    //       {
    //         id: 3168952,
    //         enterpriseName: "雁门关",
    //         enterpriseNameShort: null,
    //         enterpriseLogoImage: "",
    //         sort: null,
    //         parentId: 23,
    //         tenantId: 32,
    //         condition: "0",
    //         latLud: "112.91643,28.23202",
    //         enterpriseTreeVoList: [],
    //         fileNum: 0,
    //         auth: false,
    //         imgUrl: null,
    //         dutyName: null,
    //         dutyPhone: null,
    //         enterpriseStr: null,
    //         tenantTreeVoList: null,
    //         deptList: null,
    //         type: null,
    //       },
    //       {
    //         id: 3153517,
    //         enterpriseName: "批量导入单位测试单位",
    //         enterpriseNameShort: null,
    //         enterpriseLogoImage: null,
    //         sort: null,
    //         parentId: 23,
    //         tenantId: 32,
    //         condition: "0",
    //         latLud: "100,60",
    //         enterpriseTreeVoList: [
    //           {
    //             id: 3168546,
    //             enterpriseName: "批量导入单位测试单位06",
    //             enterpriseNameShort: null,
    //             enterpriseLogoImage: null,
    //             sort: null,
    //             parentId: 3153517,
    //             tenantId: 32,
    //             condition: "0",
    //             latLud: "112.931795,28.233940",
    //             enterpriseTreeVoList: [],
    //             fileNum: 0,
    //             auth: false,
    //             imgUrl: null,
    //             dutyName: null,
    //             dutyPhone: null,
    //             enterpriseStr: null,
    //             tenantTreeVoList: null,
    //             deptList: null,
    //             type: null,
    //           },
    //           {
    //             id: 3168521,
    //             enterpriseName: "批量导入单位测试单位04",
    //             enterpriseNameShort: null,
    //             enterpriseLogoImage: null,
    //             sort: null,
    //             parentId: 3153517,
    //             tenantId: 32,
    //             condition: "0",
    //             latLud: "112.931796,28.233940",
    //             enterpriseTreeVoList: [],
    //             fileNum: 0,
    //             auth: false,
    //             imgUrl: null,
    //             dutyName: null,
    //             dutyPhone: null,
    //             enterpriseStr: null,
    //             tenantTreeVoList: null,
    //             deptList: null,
    //             type: null,
    //           },
    //           {
    //             id: 3168496,
    //             enterpriseName: "批量导入单位测试单位03",
    //             enterpriseNameShort: null,
    //             enterpriseLogoImage: null,
    //             sort: null,
    //             parentId: 3153517,
    //             tenantId: 32,
    //             condition: "0",
    //             latLud: "112.931797,28.233940",
    //             enterpriseTreeVoList: [],
    //             fileNum: 0,
    //             auth: false,
    //             imgUrl: null,
    //             dutyName: null,
    //             dutyPhone: null,
    //             enterpriseStr: null,
    //             tenantTreeVoList: null,
    //             deptList: null,
    //             type: null,
    //           },
    //         ],
    //         fileNum: 0,
    //         auth: false,
    //         imgUrl: null,
    //         dutyName: null,
    //         dutyPhone: null,
    //         enterpriseStr: null,
    //         tenantTreeVoList: null,
    //         deptList: null,
    //         type: null,
    //       },
    //       {
    //         id: 24703,
    //         enterpriseName: "测试单位4",
    //         enterpriseNameShort: "",
    //         enterpriseLogoImage: "",
    //         sort: null,
    //         parentId: 23,
    //         tenantId: 32,
    //         condition: "0",
    //         latLud: "106.633906,28.583602",
    //         enterpriseTreeVoList: [],
    //         fileNum: 0,
    //         auth: false,
    //         imgUrl: null,
    //         dutyName: null,
    //         dutyPhone: null,
    //         enterpriseStr: null,
    //         tenantTreeVoList: null,
    //         deptList: null,
    //         type: null,
    //       },
    //       {
    //         id: 4171794,
    //         enterpriseName: "重庆万州久久养老院",
    //         enterpriseNameShort: "",
    //         enterpriseLogoImage: "",
    //         sort: null,
    //         parentId: 23,
    //         tenantId: 32,
    //         condition: "1",
    //         latLud: "108.38312,30.806462",
    //         enterpriseTreeVoList: [],
    //         fileNum: 0,
    //         auth: false,
    //         imgUrl: null,
    //         dutyName: null,
    //         dutyPhone: null,
    //         enterpriseStr: null,
    //         tenantTreeVoList: null,
    //         deptList: null,
    //         type: null,
    //       },
    //     ],
    //     fileNum: 0,
    //     auth: false,
    //     imgUrl: null,
    //     dutyName: null,
    //     dutyPhone: null,
    //     enterpriseStr: null,
    //     tenantTreeVoList: null,
    //     deptList: null,
    //     type: null,
    //   },
    //   {
    //     id: 92218,
    //     enterpriseName: "北京总部",
    //     enterpriseNameShort: null,
    //     enterpriseLogoImage: null,
    //     sort: null,
    //     parentId: 346801,
    //     tenantId: 92216,
    //     condition: null,
    //     latLud: null,
    //     enterpriseTreeVoList: [
    //       {
    //         id: 92221,
    //         enterpriseName: "华天总店",
    //         enterpriseNameShort: null,
    //         enterpriseLogoImage: null,
    //         sort: null,
    //         parentId: 92218,
    //         tenantId: 92216,
    //         condition: "0",
    //         latLud: "112.998684,28.191206",
    //         enterpriseTreeVoList: [],
    //         fileNum: 0,
    //         auth: false,
    //         imgUrl: null,
    //         dutyName: null,
    //         dutyPhone: null,
    //         enterpriseStr: null,
    //         tenantTreeVoList: null,
    //         deptList: null,
    //         type: null,
    //       },
    //       {
    //         id: 92220,
    //         enterpriseName: "北京潇湘华天",
    //         enterpriseNameShort: "单位简称",
    //         enterpriseLogoImage: "",
    //         sort: null,
    //         parentId: 92218,
    //         tenantId: 92216,
    //         condition: "0",
    //         latLud: "112.986417,28.19887",
    //         enterpriseTreeVoList: [],
    //         fileNum: 0,
    //         auth: false,
    //         imgUrl: null,
    //         dutyName: null,
    //         dutyPhone: null,
    //         enterpriseStr: null,
    //         tenantTreeVoList: null,
    //         deptList: null,
    //         type: null,
    //       },
    //     ],
    //     fileNum: 0,
    //     auth: false,
    //     imgUrl: null,
    //     dutyName: null,
    //     dutyPhone: null,
    //     enterpriseStr: null,
    //     tenantTreeVoList: null,
    //     deptList: null,
    //     type: null,
    //   },
    //   {
    //     id: 4147992,
    //     enterpriseName: "雅居乐花园",
    //     enterpriseNameShort: null,
    //     enterpriseLogoImage: null,
    //     sort: null,
    //     parentId: 4147971,
    //     tenantId: 4147420,
    //     condition: null,
    //     latLud: null,
    //     enterpriseTreeVoList: [],
    //     fileNum: 0,
    //     auth: false,
    //     imgUrl: null,
    //     dutyName: null,
    //     dutyPhone: null,
    //     enterpriseStr: null,
    //     tenantTreeVoList: null,
    //     deptList: null,
    //     type: null,
    //   },
    // ];
    if (tenantStore?.onDutyEnterpriseList?.length > 0) {
      return tenantStore?.onDutyEnterpriseList;
    } else {
      return (await tenantStore?.getTenantListByEnterpriseId()) || [];
    }
  } else {
    return (await tenantStore?.getEnterprise()) || [];
  }
}

/**
 * 设置默认选中
 */
async function setDefaultCheck() {
  await clearChecked();
  // 当前用户站点是否在当前站点树中
  // 在：默认选中当前
  defaultCheck.value.enterpriseId =
    simpleModeBaseInfo?.value?.enterpriseId ??
    userStore?.userInfo.tenantEnterpriseId;
  defaultCheck.value.tenantId =
    simpleModeBaseInfo?.value?.tenantId ?? userStore?.userInfo.tenantId;
  defaultCheck.value.name =
    simpleModeBaseInfo?.value?.enterpriseName ??
    userStore?.userInfo.enterpriseName;
  // 不在：选中第一项
  if (
    String(tenantStore?.getCurrentTenantId) !==
    String(userStore?.userInfo.tenantId)
  ) {
    if (treeData.value.length > 0) {
      console.log("非当前用户所在站点");
      defaultCheck.value.name = treeData.value[0].enterpriseName;
      defaultCheck.value.tenantId = treeData.value[0].tenantId;
      defaultCheck.value.enterpriseId = treeData.value[0].id;
    }
  }

  // 选中的单位节点
  const current = findEnterprise(
    defaultCheck.value.enterpriseId,
    treeData.value,
  );
  if (current) {
    treeRef.value?.setCheckedKeys([current.id], true);
    if (props.defaultMode === "all-child") {
      recursionSetChecked(current, true);
    }
    await handleCheckChange();
    handleVisibleChange(false);
  } else {
    console.error("未找到单位!", defaultCheck.value.enterpriseId);
  }
  if (props.isOnDuty) {
    const treeNodes = collectTreeNodes(treeData.value);
    if (props.multiple) {
      if (props.defaultEnterpriseId) {
        defaultCheck.value.tenantId = null;
        defaultCheck.value.name = null;
        defaultCheck.value.enterpriseId = props.defaultEnterpriseId;
        treeRef.value?.setCheckedKeys([props.defaultEnterpriseId], true);
      } else {
        defaultCheck.value.tenantId = getFirstTenantId(treeData.value) || null;
        defaultCheck.value.name = treeNodes?.names?.toString();
        defaultCheck.value.enterpriseId = treeNodes?.ids?.toString();
        treeRef.value?.setCheckedKeys(treeNodes?.ids, true);
      }
    } else {
      let firstNode = treeData.value[0];

      if (props.defaultEnterpriseId) {
        firstNode = {
          id: props.defaultEnterpriseId,
        };
      }
      defaultCheck.value.name = firstNode?.enterpriseName || "";
      defaultCheck.value.tenantId = getFirstTenantId(treeData.value) || null;
      defaultCheck.value.enterpriseId = firstNode?.id || null;
      treeRef.value?.setCheckedKeys([firstNode?.id].filter(Boolean), true);
    }

    await handleCheckChange();
    handleVisibleChange(false);
  }
}

/**
 * 清空所有选中
 */
async function clearChecked() {
  await nextTick();
  const checkedList = treeRef.value?.getCheckedKeys() || [];
  if (checkedList.length > 0) {
    treeRef.value?.setCheckedKeys(checkedList, false);
  }
}

/**
 * 根据单位ID在tree中查找单位
 */
function findEnterprise(enterpriseId: number, tree: any[]): any {
  let enterprise = null;
  for (let i = 0; i < tree.length; i++) {
    if (tree[i].id === enterpriseId) {
      enterprise = tree[i];
      break;
    }
    if (tree[i][CHILDREN_KEY] && tree[i][CHILDREN_KEY].length) {
      enterprise = findEnterprise(enterpriseId, tree[i][CHILDREN_KEY]);
      if (enterprise) {
        break;
      }
    }
  }
  return enterprise;
}

/**
 * 树形遍历获取第一个tenantId
 */
function getFirstTenantId(tree: any[]): number | null {
  for (let i = 0; i < tree.length; i++) {
    if (tree[i].tenantId) {
      return tree[i].tenantId;
    }
    if (tree[i][CHILDREN_KEY] && tree[i][CHILDREN_KEY].length) {
      const tenantId = getFirstTenantId(tree[i][CHILDREN_KEY]);
      if (tenantId) {
        return tenantId;
      }
    }
  }
  return null;
}

/**
 * 树形遍历收集所有节点的名称和ID
 */
function collectTreeNodes(tree: any[]): { names: string[]; ids: number[] } {
  const result: { names: string[]; ids: number[] } = { names: [], ids: [] };

  function traverse(nodes: any[]) {
    for (const node of nodes) {
      if (node.enterpriseName) {
        result.names.push(node.enterpriseName);
      }
      if (node.id) {
        result.ids.push(node.id);
      }
      if (node[CHILDREN_KEY] && node[CHILDREN_KEY].length) {
        traverse(node[CHILDREN_KEY]);
      }
    }
  }

  traverse(tree);
  return result;
}
/**
 * 节点选中状态变化
 */
async function handleCheckChange() {
  await nextTick();
  const checkedList = treeRef.value?.getCheckedNodes(false) || [];
  const val = checkedList.map(
    (item: any) => item.enterpriseName || item.tenantName,
  );
  modelValue.value = props.multiple ? val : val[0];
  if (!props.multiple) {
    // 单选时，选中之后就隐藏下拉框
    selectRef.value.blur();
  }
}

/**
 * el-select 面板 显示、隐藏
 */
function handleVisibleChange(visible: boolean) {
  if (!visible) {
    const diff = diffChecked();
    if (!diff) {
      const checkedList = treeRef.value?.getCheckedNodes() || [];
      if (checkedList.length === 0) {
        setDefaultCheck();
      } else {
        const arrObj: Record<string, any[]> = {
          name: [],
          enterpriseId: [],
          tenantId: [],
        };
        const arr = checkedList.map((item: any) => {
          arrObj.name.push(item.enterpriseName || item.tenantName);
          arrObj.enterpriseId.push(item.id);
          if (!arrObj.tenantId.includes(item.tenantId)) {
            arrObj.tenantId.push(item.tenantId);
          }
          return {
            name: item.enterpriseName || item.tenantName,
            enterpriseId: item.id,
            tenantId: item.tenantId || item.id,
          };
        });
        emits("change", {
          arr,
          obj: {
            name: arrObj.name.join(","),
            enterpriseId: arrObj.enterpriseId.join(","),
            tenantId: arrObj.tenantId.join(","),
          },
        });
      }
    }
  } else {
    // 重置过滤
    searchValue.value = "";
    handleSearch();
  }
}

/**
 * 比较选中节点是否发生变化
 */
function diffChecked() {
  const checkedList = treeRef.value?.getCheckedNodes() || [];
  const checkedKeys = checkedList
    .map((item: any) => item[NODE_KEY])
    .filter(Boolean);
  // 比较 checkedKeys 和 cacheChangeKeys
  const diff = diffArr(checkedKeys, cacheChangeKeys);
  cacheChangeKeys = checkedKeys;
  return diff;
}

/**
 * 比较两个数组是否相等
 * 数组下标不影响结果，即 [1,2] 等于 [2,1] 返回true
 */
function diffArr(arr1: number[], arr2: number[]): boolean {
  if (arr1.length !== arr2.length) {
    return false;
  }
  const sortedArr1 = [...arr1].sort();
  const sortedArr2 = [...arr2].sort();
  for (let i = 0; i < sortedArr1.length; i++) {
    if (sortedArr1[i] !== sortedArr2[i]) {
      return false;
    }
  }
  return true;
}

/**
 * 触发过滤
 */
function handleSearch() {
  treeRef.value?.filter(searchValue.value);
  if (!searchValue.value) {
    // 如果过滤为空，则展开默认选中的节点
    setDefaultExpanded();
  }
  // 实现搜索高亮
  highlightNodes(treeData.value, searchValue.value);
}

/**
 * 高亮节点标签
 * @param nodes - 节点数组
 * @param query - 搜索关键词
 */
function highlightNodes(nodes: any[], query: string) {
  nodes.forEach((node: any) => {
    if (node[CHILDREN_KEY] && node[CHILDREN_KEY].length > 0) {
      highlightNodes(node[CHILDREN_KEY], query);
    }
    if (query && (node.enterpriseName || node.tenantName)) {
      const label = node.enterpriseName || node.tenantName;
      const regex = new RegExp(`(${query})`, "gi");
      node.label = label.replace(regex, '<span class="highlight">$1</span>');
    } else {
      // 如果没有搜索关键词，则恢复节点标签
      node.label = node.enterpriseName || node.tenantName;
    }
  });
}

/**
 * 点击checkbox选择框
 */
const handleCheck = async (data: any) => {
  await nextTick();
  const checkedList = treeRef.value?.getCheckedKeys() || [];
  const isChecked = checkedList.includes(data[NODE_KEY]);
  if (props.multiple) {
    // 多选
    recursionSetChecked(data, isChecked);
  } else {
    // 单选
    // 取消其他选中
    checkedList.forEach((item: any) => {
      if (item !== data[NODE_KEY]) {
        treeRef.value?.setChecked(item, false);
      }
    });
  }
};

/**
 * 递归设置选中/取消选中
 * @param data
 * @param isChecked
 */
function recursionSetChecked(data: any, isChecked: boolean) {
  if (data[CHILDREN_KEY] && data[CHILDREN_KEY].length > 0) {
    // 选中/取消子节点
    data[CHILDREN_KEY].forEach((item: any) => {
      treeRef.value?.setChecked(item[NODE_KEY], isChecked);
      recursionSetChecked(item, isChecked);
    });
  }
}

/**
 * 点击树节点
 */
const handleNodeClick = async (data: any) => {
  await nextTick();
  const checkedList = treeRef.value?.getCheckedKeys() || [];
  if (props.multiple) {
    const isChecked = checkedList.includes(data[NODE_KEY]);
    treeRef.value?.setChecked(data[NODE_KEY], !isChecked);
  } else {
    // 单选
    treeRef.value?.setChecked(data[NODE_KEY], true);
    // 取消其他选中
    checkedList.forEach((item: any) => {
      if (item !== data[NODE_KEY]) {
        treeRef.value?.setChecked(item, false);
      }
    });
  }
  await handleCheckChange();
};

/**
 * 节点过滤
 */
const filterMethod = (query: string, node: any) => {
  const label = node?.enterpriseName || node?.tenantName;
  return new RegExp(query, "i").test(label);
};

/**
 * 根据当前选中节点，设置展开的节点
 */
function setDefaultExpanded() {
  const checkedKeys = treeRef.value?.getCheckedKeys() || [];
  if (checkedKeys.length === 0) return;
  // 1、调用 findParentEnterprise 查找父节点数组
  // 2、过滤掉无效数组，最上层的节点找不到父节点会返回null
  // 3、展开二维数组
  // 4、得到 单位ID 数组
  const expandedKeys = checkedKeys
    .map((item: any) => {
      return findParentEnterprise(item, treeData.value);
    })
    .filter(Boolean)
    .flat()
    .map((item: any) => item[NODE_KEY]);
  treeRef.value?.setExpandedKeys([...checkedKeys, ...expandedKeys]);

  if (treeRef.value && treeRef.value?.scrollTo) {
    const top = getNodeTop(checkedKeys[0]);
    treeRef.value.scrollTo(top);
  }
}

/**
 * 根据单位ID在tree中查找父级单位
 * @param enterpriseId - 要查找的单位ID
 * @param tree - 当前树数据
 * @returns {Array|null} - 返回从根到子的父级单位数组，未找到则返回 null
 */
function findParentEnterprise(enterpriseId: number, tree: any[]): any[] | null {
  const traverse = (node: any, path: any[], targetId: number): any[] | null => {
    // 如果当前节点是目标节点，则返回当前路径（不包含自己）
    if (node.id === targetId) {
      return path.length > 0 ? [...path] : null;
    }

    // 如果有子节点，继续递归查找
    if (node[CHILDREN_KEY] && node[CHILDREN_KEY].length > 0) {
      for (let i = 0; i < node[CHILDREN_KEY].length; i++) {
        const result = traverse(
          node[CHILDREN_KEY][i],
          [...path, node],
          targetId,
        );
        if (result) {
          return result;
        }
      }
    }

    return null;
  };

  // 遍历整个树，尝试在每个顶级节点下查找
  for (let i = 0; i < tree.length; i++) {
    const result = traverse(tree[i], [], enterpriseId);
    if (result) {
      return result;
    }
  }

  return null;
}

/**
 * 根据选中的key值，获取到节点离顶端的距离
 * @param key
 */
function getNodeTop(key: number | string) {
  // 节点高度
  const LINE_HEIGHT = 32;
  const node = treeRef.value?.getNode(key);
  const level = node.level;
  let top = 0;
  let _node = node;
  for (let i = 1; i < level; i++) {
    const children = _node?.parent?.children || [];
    const index = children.findIndex((item: any) => item.key === _node.key);
    top += index * LINE_HEIGHT;
    _node = _node.parent;
  }
  return top;
}
// todo element-plus 需升级为 2.9.0+
// @ts-ignore
const nodeClass = (data: any, node: any) => {
  if (node.children && node.children?.length > 0) {
    return "";
  }
  return "tenant-e-empty-node";
};
</script>

<template>
  <div v-show="!isSimple" class="t-tenant-enterprise">
    <label v-if="showLabel" class="t-tenant-enterprise__label">{{
      label
    }}</label>
    <ElSelect
      ref="selectRef"
      v-model="modelValue"
      :multiple="multiple"
      collapse-tags
      :clearable="false"
      style="width: 240px"
      placement="bottom-end"
      :popper-class="`tenant-enterprise-popper ${popperClass}`"
      @visible-change="handleVisibleChange"
    >
      <template #empty>
        <div class="t-tenant-enterprise__search">
          <ElInput
            v-model="searchValue"
            placeholder="输入关键词,按Enter键搜索..."
            clearable
            maxlength="30"
            @change="handleSearch"
          />
        </div>
        <div :id="treeContainerId" v-loading="loading" class="p-2">
          <ElTreeV2
            ref="treeRef"
            :height="300"
            class="tenant-enterprise-tree"
            :class="{
              'tenant-enterprise-tree__only': !multiple,
            }"
            :data="treeData"
            :props="{
              children: CHILDREN_KEY,
              class: nodeClass,
            }"
            highlight-current
            :expand-on-click-node="false"
            check-on-click-node
            :default-expanded-keys="[]"
            show-checkbox
            check-strictly
            :default-checked-keys="[]"
            :filter-method="filterMethod"
            :indent="30"
            :item-size="32"
            :node-key="NODE_KEY"
            @check="handleCheck"
            @check-change="handleCheckChange"
          >
            <template #default="{ node }">
              <TreeLine
                :node="node"
                show-label-line
                @click.stop="handleNodeClick(node.data)"
              >
                <template #node-label>
                  <span
                    :title="node.data?.enterpriseName || node?.data.tenantName"
                    v-html="
                      node.data?.label ||
                      node.data?.enterpriseName ||
                      node?.data.tenantName
                    "
                  />
                </template>
              </TreeLine>
            </template>
          </ElTreeV2>
        </div>
      </template>
    </ElSelect>
  </div>
</template>
